import { Pin } from 'lucide-react';
import { cn } from './utils';
import { isPathPinned, togglePinnedPath, usePinnedPaths } from './navPins';

/**
 * SIL-364: per-page Pin/Pinned toggle for the pillar-rail nav's "Pinned"
 * view. `to` is the page's own nav route (pin identity); `label` is the
 * page title, used only for the accessible name.
 */
export function PinToggle({ to, label, className }: { to: string; label: string; className?: string }) {
  usePinnedPaths(); // subscribe so this re-renders when the pin set changes elsewhere
  const pinned = isPathPinned(to);

  return (
    <button
      type="button"
      onClick={() => togglePinnedPath(to)}
      aria-pressed={pinned}
      aria-label={pinned ? `Unpin ${label} from nav` : `Pin ${label} to nav`}
      title={pinned ? 'Unpin from nav' : 'Pin to nav'}
      className={cn(
        'flex items-center justify-center rounded-md p-1.5 transition-colors',
        pinned
          ? 'text-brand-600 hover:bg-brand-50'
          : 'text-muted-foreground/50 hover:bg-muted hover:text-muted-foreground',
        className,
      )}
    >
      <Pin className={cn('size-4', pinned && 'fill-current')} />
    </button>
  );
}
